module.exports = __webpack_public_path__ + "static/img/vup.28aa479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/vup.png
// module id = g5xi
// module chunks = 0